import API from '@/api/park/contract';
export default {
  methods: {
    // 重置按钮
    resetBtnClick() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.$refs.siruiTable.clearCheckboxReserve();
      this.selectedItems = [];
      this.getTableData();
    },
    // 搜索按钮
    searchTrigger() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.clearCheckboxReserve();
      this.getTableData(true);
    },
    // 表格上面的按钮
    chooseClick(type) {
      this[type]();
    },
    //新增 触发事件
    create() {
      let path = {
        path: 'warehouse/contractMaintainance',
        name: 'contractMaintainance',
        meta: {
          keepAlive: true,
          title: '合同维护',
        },
        query: {
          pageMode: 0,
        },
      };
      this.$router.push(path);
    },
    // 列表双击
    dblclickEvent(type) {
      const path = {
        path: '/warehouse/contractDetail',
        name: 'contractDetail',
        meta: {
          keepAlive: true,
          title: '合同详情',
        },
        query: {
          id: type.row.id,
          pageMode: 1,
          isEdit: false,
        },
      };
      this.$router.push(path);
    },
    // 关闭  触发事件
    async close() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const contractStatus = this.multipleSelection[0].contractStatus;
      if (contractStatus == 'ZT03') {
        await this.getSettlementList();
        this.$refs.closeContractRef.openDialog();
      } else {
        this.$message.error('只有已生效状态的合同才能关闭！');
      }
    },
    // 导出 触发事件
    async exportHandler() {
      const idList = this.multipleSelection.map((item) => item.id);
      let data;
      if (!idList.length && !this.tableData) {
        this.$message.error('没有数据可以导出！');
        return;
      }
      const tableList = this.tableData.map((item) => item.id);
      if (!idList.length) {
        this.isLoading = true;
        data = await this.$axios.post(API.EXPORT_CONTRACT, { ids: tableList });
        this.isLoading = false;
      }
      this.isLoading = true;
      data = await this.$axios.post(API.EXPORT_CONTRACT, { ids: idList });
      this.isLoading = false;
      if (data.data.code === 0) {
        window.location.href = data.data.data;
        this.$message.success('导出成功');
      } else {
        this.$message.error('导出失败');
      }
    },
    // 续签 触发事件
    renew() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const contractStatus = this.multipleSelection[0].contractStatus;
      if (contractStatus == 'ZT03') {
        let path = {
          path: 'warehouse/contractRenew',
          name: 'contractRenew',
          meta: {
            keepAlive: true,
            title: '合同续签',
          },
          query: {
            pageMode: 3,
            id: this.multipleSelection[0].id,
          },
        };
        this.$router.push(path);
      } else {
        this.$message.error('只有已生效状态的合同才能续签！');
      }
    },
    // 变更合同 触发事件
    changeContract() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const contractStatus = this.multipleSelection[0].contractStatus;
      if (contractStatus == 'ZT03') {
        let path = {
          path: 'warehouse/contractChange',
          name: 'contractChange',
          meta: {
            keepAlive: true,
            title: '合同信息变更',
          },
          query: {
            pageMode: 4,
            id: this.multipleSelection[0].id,
          },
        };
        this.$router.push(path);
      } else {
        this.$message.error('只有已生效状态的合同才能变更合同信息！');
      }
    },
    // 变更主体 触发事件
    changeSubject() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const contractStatus = this.multipleSelection[0].contractStatus;
      if (contractStatus == 'ZT03') {
        this.$refs.changeSubjectRef.openDialog();
      } else {
        this.$message.error('只有已生效状态的合同才能变更主体！');
      }
    },
    // 审批 触发事件
    approve() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const contractStatus = this.multipleSelection[0].contractStatus;
      if (contractStatus == 'ZT02') {
        let path = {
          path: 'warehouse/contractApprove',
          name: 'contractApprove',
          meta: {
            keepAlive: true,
            title: '合同审批',
          },
          query: {
            pageMode: 2,
            id: this.multipleSelection[0].id,
            contractNo: this.multipleSelection[0].contractNo,
          },
        };
        this.$router.push(path);
      } else {
        this.$message.error('只有待审批状态的合同才能审批！');
      }
    },
    // 删除 触发事件
    delete() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择要删除的行');
        return;
      }
      this.deleteIds = this.multipleSelection.map((item) => item.id);
      const isDelete = this.multipleSelection.every((item) =>
        ['ZT01'].includes(item.contractStatus)
      );
      if (!isDelete) {
        this.deleteIds = [];
        this.$message.error('只有保存和驳回的单才可以删除');
        return;
      }
      console.log(this.deleteIds, '删除的ids');
      this.$refs.deleteContractRef.openDialog();
      this.resetBtnClick();
    },
    // 选择一行判断
    checkSelectOneData() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择一行操作');
        return false;
      }
      if (this.multipleSelection.length != 1) {
        this.$message.error('只能选择一行操作');
        return false;
      }
      return true;
    },
  },
};
